import styled from "styled-components"

const StepBoxItem = ({ isCompleted }: { isCompleted: boolean }) => {
  return <CircleDiv $isCompleted={isCompleted} />
}

export default StepBoxItem

const CircleDiv = styled.div<{ $isCompleted: boolean }>`
  border-radius: 50%;
  background-color: ${({ $isCompleted }) =>
    $isCompleted ? "var(--custom-blue)" : "var(--custom-platinum)"};
  width: 19px;
  height: 19px;
`
